export default "__VITE_ASSET__BNqM80$l__"